import React from "react";
import Misc from "../../../misc/misc";

const dayView = ({number, click, selected}) =>
    (
        <div className="confirmation-calendar-day-unit"
             onClick={e => Misc.ignore(e, () => click && click(number))}>
            <div className="confirmation-calendar-number">{number}</div>
            {selected ? <div className="confirmation-calendar-cursor"/> : null}
        </div>
    );


dayView.displayName = 'Day View';

export default dayView;

